import { LoaderFunctionArgs, Outlet } from 'react-router';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { VaultFragment } from '@/shared/types/types.generated';

export const innerVaultRoutes: TCustomRouteObject[] = [
  {
    path: ':vaultId/:tabId?',
    lazy: async () => {
      const { Vault } = await import('./vault');
      return { Component: Vault };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { vaultLoader } = await import('./vault');
      return vaultLoader(args);
    },
    handle: {
      crumb: {
        label: (data: VaultFragment) => data.name,
      },
    },
  },
];

export const vaultRouteHandle: THandle = {
  crumb: {
    label: 'vaults',
    localized: true,
  },
};

export const securityHubRoutes: TCustomRouteObject = {
  path: '/security-hub',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'security-hub',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { SecurityHubRoute } = await import('./security-hub');
        return { Component: SecurityHubRoute };
      },
    },
    {
      path: 'vaults',
      Component: () => <Outlet />,
      handle: vaultRouteHandle,
      children: [
        {
          index: true,
          lazy: async () => {
            const { VaultsRoute } = await import('./vaults');
            return { Component: VaultsRoute };
          },
        },
        ...innerVaultRoutes,
      ],
    },
    {
      path: 'audit-logs',
      Component: () => <Outlet />,
      handle: {
        crumb: {
          label: 'audit_logs',
          localized: true,
        },
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { AuditLogsRoute } =
              await import('@/shared/app/routes/audit-logs/audit-logs');
            return { Component: AuditLogsRoute };
          },
        },
      ],
    },
    {
      path: 'vulnerabilities',
      Component: () => <Outlet />,
      handle: {
        crumb: {
          label: 'vulnerabilities',
          localized: true,
        },
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { VulnerabilitiesRoute } = await import('./vulnerabilities');
            return { Component: VulnerabilitiesRoute };
          },
        },
      ],
    },
  ],
};
